export default "__VITE_ASSET__fMBkllay__"